// 네이티브 푸시 등록 골격 — Capacitor PushNotifications.
// 웹에서는 아무 동작도 하지 않음(기존 웹 푸시 흐름은 lib/push 웹훅 그대로 유지).
// 실제 발송 키(FCM google-services.json 등)는 추후 연동. 지금은 토큰을 백엔드에 저장만.
import api from "../api";
import { isNative, getPlatform } from "./platform";
import { NATIVE_PUSH_ENABLED } from "./config";

let initialized = false;

export const initNativePush = async () => {
  if (!isNative() || initialized) return;
  // Firebase 미설정 시 네이티브 푸시 전체를 호출 자체 없이 건너뜀(네이티브 크래시 방지).
  // 토큰 백엔드 전송도 함께 건너뜀. 웹 푸시(VAPID)는 이 함수와 무관하게 그대로 동작.
  if (!NATIVE_PUSH_ENABLED) {
    console.log("Native push skipped (Firebase not configured)");
    return;
  }
  initialized = true;
  let PushNotifications;
  try {
    ({ PushNotifications } = await import("@capacitor/push-notifications"));
  } catch (e) {
    return; // 플러그인 미설치 시 조용히 스킵
  }
  try {
    let perm = await PushNotifications.checkPermissions();
    if (perm.receive !== "granted") perm = await PushNotifications.requestPermissions();
    if (perm.receive !== "granted") return;

    await PushNotifications.addListener("registration", async (token) => {
      try {
        await api.post("/push/native-token", { token: token.value, platform: getPlatform() });
      } catch (e) { /* 등록 실패는 조용히 무시(골격) */ }
    });
    await PushNotifications.addListener("registrationError", () => { /* noop */ });

    await PushNotifications.register();
  } catch (e) {
    /* noop — 골격 단계 */
  }
};
